import { useState, useEffect } from 'react';
import get from 'lodash/get';
import { useDecision } from '@optimizely/react-sdk';
import { useTrackOptimizely } from '@fff-web/fff-analytics';

const useReactivateContent = () => {
  const [content, setContent] = useState({});
  const [reactivateDecision] = useDecision('growth-reactivations_loggedin');
  const { optimizelyTrack } = useTrackOptimizely(reactivateDecision, 'growth-reactivations_loggedin-1_0_0');
  const reactivationsLoggedInTrack = optimizelyTrack;
  const getContentKey = (key, defaultValue = '') => get(content, key, defaultValue);
  useEffect(() => {
    const optimizelyContent = { ...reactivateDecision.variables.content };
    setContent(optimizelyContent);
  }, [reactivateDecision]);

  return { getContentKey, reactivationsLoggedInTrack };
};

export default useReactivateContent;
